const Theme = {
  breakpoints: ['768px', '992px']
};

export default Theme;
export { Theme };
